import styled, { css } from 'styled-components'
import { AsyncTypeahead, Typeahead, ClearButton } from 'react-bootstrap-typeahead'

const commonStyle = css`
  .dropdown-menu {
    max-height: 600px !important;
  }
  .dropdown-item {
    font-size: 0.8rem;
    font-weight: 300;
    &.disabled {
      color: ${({ theme }) => theme.palette.grayscale[3]};
    }
    white-space: normal;
  }

  // Clear button alignment
  .rbt-aux .rbt-close {
    margin-top: 2px;
    z-index: 0;
    &:focus {
      outline: none;
    }
    ${({ active }) => active && css`
      color: ${({ theme }) => theme.palette.primary[0]};
      font-weight: 600;
      opacity: 1;
    `}
  }

  .rbt-token {
    ${({ isRightIcon }) => isRightIcon && css`
      max-width: 80%;
    `}
  }
  
  .rbt-input {
    // Give some space for the clear button to show
    padding-right: 30px;
    ${({ isRightIcon }) => isRightIcon && css`
      padding-right: 3rem;

      .rbt-input-wrapper {
        margin-right: 1rem;
      }
      
    `}

    border-radius: 0;
  }

  .rbt-input-hint {
    display: none;
  }

  a {
    // Give some space between list options
    padding: 0.5rem;
  }

  ${({ active }) =>
  active &&
  css`
    [class*='-control'] {
      background-color: ${({ theme }) => theme.palette.primary[4]};
      border: 1px solid ${({ theme }) => theme.palette.primary[4]};
      color: ${({ theme }) => theme.palette.primary[0]};
      font-weight: 600;
      font-style: italic;
    }
  `
}`

export const StyledAsyncTypeahead = styled(AsyncTypeahead)`${commonStyle}`
export const StyledTypeahead = styled(Typeahead)`${commonStyle}`

export const StyledClearButton = styled(ClearButton)`
  color: ${({ theme }) => theme.palette.grayscale[4]};
  font-size: 1.3rem;
`
